import React from "react";

/**
 * SectionCard — unified content panel (sharp border + colored header strip).
 *
 *  - title: section title (rendered in header strip)
 *  - eyebrow: optional smaller pre-title in header
 *  - icon: lucide icon in header
 *  - tone: "navy" (default) | "yellow" | "danger" | "white"
 *  - actions: right slot inside header
 *  - padded: wrap children in default p-4 padding
 *  - footer: optional footer slot under the body
 */
const HEADER_TONE = {
  navy: "bg-zinc-900 text-white",
  yellow: "bg-[#FFC60A] text-zinc-900",
  danger: "bg-red-100 text-red-900",
  white: "bg-white text-zinc-900 border-b border-zinc-900",
  emerald: "bg-emerald-600 text-white",
};

export function SectionCard({
  title,
  eyebrow,
  icon: Icon,
  tone = "navy",
  actions,
  children,
  footer,
  padded = false,
  className = "",
  bodyClassName = "",
  testId,
}) {
  return (
    <section data-testid={testId} className={`border border-zinc-900 bg-white ${className}`}>
      {(title || eyebrow || Icon || actions) && (
        <div className={`px-3 py-2 flex items-center justify-between gap-2 ${HEADER_TONE[tone] || HEADER_TONE.navy}`}>
          <div className="flex items-center gap-2 min-w-0">
            {Icon && <Icon size={12} className="shrink-0" />}
            <div className="min-w-0">
              {eyebrow && <div className="text-[9px] font-mono uppercase tracking-[0.3em] opacity-70">{eyebrow}</div>}
              {title && <div className="text-[10px] font-mono uppercase tracking-widest font-bold truncate">{title}</div>}
            </div>
          </div>
          {actions && <div className="flex items-center gap-1.5 shrink-0">{actions}</div>}
        </div>
      )}
      <div className={`${padded ? "p-4" : ""} ${bodyClassName}`}>{children}</div>
      {footer && <div className="border-t border-zinc-200 px-3 py-2 bg-zinc-50">{footer}</div>}
    </section>
  );
}
